<template>
  <v-row>
    <v-col cols="12" :md="modalView ? 12 : 6" :offset-md="modalView ? 0 : 3">
    <div v-if="asyncDataStatus_ready" class="col-full push-top">
      <h2>
        Pregled aktivnih modulov blagajn:
      </h2>
      <form @submit.prevent="save">
        <v-checkbox
          color="#0F998E"
          disabled
          v-model="delovnicasstatus"
          label="Vodenje delovnega časa"
        ></v-checkbox>
        <v-checkbox
          color="#0F998E"
          disabled
          v-model="uporabamizstatus"
          label="Uporaba miz"
        ></v-checkbox>
        <v-checkbox
          color="#0F998E"
          disabled
          v-model="uporabanarocilstatus"
          label="Uporaba naročil"
        ></v-checkbox>
        <!-- <v-btn
          type="submit"
          color="#0F998E"
          class="white--text float-right"
        >Shrani</v-btn>
        <v-btn
          text
          type="button"
          class="float-right mr-4"
          @click="$router.go(-1)"
        >Prekliči</v-btn> -->
      </form>
    </div>
    </v-col>
  </v-row>
</template>

<script>
// import { mapActions } from 'vuex'
// import { loadItem, saveItem } from '@/utils/crudFunctions'
import asyncDataStatus from '@/mixins/asyncDataStatus'

export default {
  data () {
    return {
      delovnicasstatus: null,
      uporabamizstatus: null,
      uporabanarocilstatus: null
    }
  },
  components: {
    // UserTypeForm
  },
  mixins: [
    asyncDataStatus
  ],
  computed: {
    petype () {
      return this.$store.state.businessUnits.currentBusinessUnit.name
    },
    aktiviranDc () {
      return this.$store.state.businessUnits.currentBusinessUnit.work_time
    },
    aktiviraneMize () {
      return this.$store.state.businessUnits.currentBusinessUnit.table_work
    },
    aktiviranaNarocila () {
      return this.$store.state.businessUnits.currentBusinessUnit.ordering
    }
  },
  methods: {
    // ...mapActions('delovnicas', ['statusDelovnegaCasa']),
    /* save (form) {
      this.statusDelovnegaCasa(this.delovnicasstatus)
      const zapisanStatus = this.delovnicasstatus === 0 ? 'onemogočen' : 'omogočen'
      this.$notify({
        type: 'success',
        text: `Delovni čas je ${zapisanStatus}!`
      })
    } */
  },
  created () {
    // loadItem(this)
    this.delovnicasstatus = this.aktiviranDc
    this.uporabamizstatus = this.aktiviraneMize
    this.uporabanarocilstatus = this.aktiviranaNarocila
    this.asyncDataStatus_fetched()
  },
  watch: {
    /* delovnicasstatus (status) {
      this.delovnicasstatus = status ? 1 : 0
    } */
  }
}
</script>
